/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import { useState } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button, Modal, notification } from "antd";
import { RightOutlined } from "@ant-design/icons";

// Custom Components & Functions Block
import ProfileIcon from "../../../../_assets/logos/profile.svg?react";
import ProfileIcon1 from "../../../../_assets/logos/profile1.svg?react";
import EmailIcon from "../../../../_assets/logos/email.svg?react";
import EllipseIcon from "../../../../_assets/logos/success-Ellipse.svg?react";
import { Permission, hasPermissions } from "../../../../../app/modules/Common/constants";
import { logOutUser } from "./../../../../../app/modules/User/_redux/users/usersCrud";
import { handleApiErrorResponse } from "./../../../../../app/modules/Common/utils";

export function QuickUser({ toggleDrawer }) {
  const history = useHistory();
  const { currentState } = useSelector((state) => ({ currentState: state.auth }), shallowEqual);
  const { entity } = currentState.user;
  const isMasterAdmin = !!entity?.master_admin;
  const canChangePassword = isMasterAdmin || hasPermissions([Permission.GeneratePasswordPin])[0];
  const [showConfirmationLogoutForAllDevices, setShowConfirmationLogoutForAllDevices] = useState(false);
  const handleCloseClickLogOutAllDevices = () => {
    setShowConfirmationLogoutForAllDevices(false);
  };

  const logoutClick = async (logoutFromAllDevices = false) => {
    try {
      if (logoutFromAllDevices) {
        const response = await logOutUser();
        const backendMsg = response?.data?.message || "Logged out from all devices successfully";
        notification.success({ message: backendMsg });
      }

      // Shutdown Intercom (if available)
      if (window.Intercom) {
        window.Intercom("shutdown");
      }

      // Trigger user toggle click
      const toggle = document.getElementById("kt_quick_user_toggle");
      if (toggle) {
        toggle.click();
      }

      // remove access token in the localstorage
      localStorage.removeItem("access_token");
      // Redirect to logout page and reload
      history.push("/logout");
      window.location.reload();
    } catch (error) {
      handleApiErrorResponse(error);
    }
  };

  const handleClickLogOutAllDevices = () => {
    setShowConfirmationLogoutForAllDevices(true);
  };

  return (
    <>
      <div className="profile">
        <div className="">
          <div className="profile-main-container">
            <div className="profile-image">
              <img src={entity?.image || "/media/stock-600x400/placeholder.png"} alt="Logo" className="h-100 w-100 rounded" />
            </div>
            <div className="profile-info-container">
              <div className="user-info">
                <div className="user-name">{entity?.first_name}</div>
                <div className="user-role">
                  <EllipseIcon style={{ marginRight: "8px" }} />
                  {entity?.last_name || "Active"}
                </div>
              </div>
              <div className="email-container">
                <EmailIcon style={{ height: "22px", width: "22px" }} />
                <div className="user-email">{entity?.email}</div>
              </div>
              <div className="quick-user-actions">
                <button className="logout-btn" onClick={() => logoutClick(false)}>
                  <FormattedMessage id="Log out" defaultMessage="Log out" />
                </button>
                <button className="logout-btn" onClick={handleClickLogOutAllDevices}>
                  <FormattedMessage id="Log out All Devices" defaultMessage="Log out All Devices" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="user-container">
        <div className="quick-user-section-title">Account</div>
        <div className="user-listing">
          {canChangePassword && (
            <div className="list-item" onClick={toggleDrawer}>
              <NavLink to="/users/profile" className="list-item">
                <div className="list-link">
                  <span className="icon-container">
                    <ProfileIcon />
                  </span>
                  <div className="navi-text">
                    <div className="profile-text">
                      <FormattedMessage id="My Profile" defaultMessage="My Profile" />
                    </div>
                    <div className="sub-text">
                      <FormattedMessage id="Account settings and more" defaultMessage="Account settings and more" />{" "}
                    </div>
                  </div>
                <RightOutlined className="quick-user-row-arrow" />
                </div>
              </NavLink>
            </div>
          )}
          {hasPermissions(Permission.UserUpdate)[0] ? (
            <div className="list-item" onClick={toggleDrawer}>
              <NavLink to="/users/user">
                <div className="list-link">
                  <span className="icon-container">
                    <ProfileIcon1 />
                  </span>
                  <div className="navi-text">
                    <div className="profile-text">
                      <FormattedMessage id="User Profile" defaultMessage="User Profile" />
                    </div>
                    <div className="sub-text">
                      <FormattedMessage id="User accounts and settings" defaultMessage="User accounts and settings" />
                    </div>
                  </div>
                  <RightOutlined className="quick-user-row-arrow" />
                </div>
              </NavLink>
            </div>
          ) : null}
          <Modal
            title={"Are you sure?"}
            visible={showConfirmationLogoutForAllDevices}
            onCancel={handleCloseClickLogOutAllDevices}
            footer={[
              <Button key="cancel" onClick={handleCloseClickLogOutAllDevices}>
                Cancel
              </Button>,
              <Button
                key="logout-for-all-devices"
                type="primary"
                onClick={() => {
                  logoutClick(true);
                  handleCloseClickLogOutAllDevices();
                }}
              >
                Yes
              </Button>,
            ]}
            centered
          >
            <div>
              <p style={{ marginLeft: "26px" }}>You want to logout from all devices ?</p>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}
